
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, HelpCircle, FileText } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

// Update the footerLinks to include Documentation
export const footerLinks = [
  { name: "Help Center", href: "/help-center", icon: HelpCircle },
  { name: "Documentation", href: "/documentation", icon: FileText },
  { name: "About Us", href: "/about-us", icon: BookOpen },
  { name: "Terms & Conditions", href: "/terms-conditions", icon: BookOpen },
  { name: "Privacy Policy", href: "/privacy-policy", icon: BookOpen }
];

interface SidebarFooterProps {
  onCloseSidebar?: () => void;
}

const SidebarFooter: React.FC<SidebarFooterProps> = ({ onCloseSidebar }) => {
  const navigate = useNavigate();

  const handleClick = (href: string) => {
    navigate(href);
    if (onCloseSidebar) {
      onCloseSidebar();
    }
  };

  return (
    <div className="mt-auto">
      <div className="border-t border-slate-800 pt-2 pb-2">
        <div className="px-3">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="flex items-center py-2 px-3 rounded-md transition-colors text-muted-foreground hover:bg-muted hover:text-foreground w-full justify-start">
                <BookOpen size={18} className="mr-2" />
                <span>About</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-48 bg-popover">
              {footerLinks.map((link) => (
                <DropdownMenuItem 
                  key={link.name}
                  onClick={() => handleClick(link.href)}
                  className="cursor-pointer"
                >
                  <link.icon size={18} className="mr-2" />
                  <span>{link.name}</span>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

export default SidebarFooter;
